export const SafeDiv: React.FC<{ className?: string }> = ({
  children,
  className,
}) => (
  <div
    className={className}
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{
      __html: typeof children === 'string' ? children : '',
    }}></div>
);

export const SafeSpan: React.FC<{ className?: string }> = ({
  children,
  className,
}) => (
  <span
    className={className}
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{
      __html: typeof children === 'string' ? children : '',
    }}>
    {/* {children} */}
  </span>
);
export const SafeHtmlContent: React.FC<{ className?: string }> = ({
  children,
  className = '',
}) => (
  <article className={`tui-editor-contents relative  ${className}`}>
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: typeof children === 'string' ? children : '',
      }}></div>
  </article>
);
export const SafePostHtmlContent: React.FC<{ className?: string }> = ({
  children,
  className = '',
}) => (
  <article className={`tui-editor-contents syl-editor ${className}`}>
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: typeof children === 'string' ? children : '',
      }}></div>
  </article>
);
